(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'PackageBookingReview',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('.edit-hotel-time').on('click', function onClick(e)
		{
			var $self     = $(this),
			    $parent   = $self.parent('.time-controls'),
			    $field    = $parent.find('.edit-time'),
			    $static   = $parent.find('.static-time'),
			    input_val = $parent.find('input').val();
			e.preventDefault();

			if ((!$field.hasClass('hidden')) && (input_val.length > 0)) {
				$static.html(input_val);
			}

			$field.toggleClass('hidden');
		});

		$('.lodging-chain').on('change', function onChange(e)
		{
			toggleAllInclusives($(this));
		});

		function toggleAllInclusives($hotel_el)
		{
			var hotel_id             = $hotel_el.val(),
			    $parent              = $hotel_el.closest('.hotel-grouping'),
			    $row                 = $parent.find('.all-inclusive-row'),
			    $all_inclusive_input = $row.find('.all-inclusive'),
			    vendor_id;

			$row.addClass('hidden');
			$all_inclusive_input.prop('disabled', true);

			$all_inclusive_input.empty();
			$all_inclusive_input.append($('<option>').text('').attr('value', ''));

			if (hotel_id === '') {
				return;
			}

			// get vendor ID for hotel
			Adzuki.Ajax.get('/Vendors/getVendorId/lodging/hotels/' + hotel_id).then(function success(vendor) {
				vendor_id = vendor.vendor_id;

				Adzuki.Ajax.get('/AllInclusiveProperties/getProperties/' + vendor_id).then(function success(properties) {
					var sorted_properties = Adzuki.Sort.alphabeticValue(properties);

					if (sorted_properties.length > 0) {
						$.each(sorted_properties, function loadProperty(i, property) {
							$all_inclusive_input.append($('<option>').text(property.value).attr('value', property.key));
						});

						$all_inclusive_input.prop('disabled', false);
						$row.removeClass('hidden');
					}
				});
			});
		}
	};

}(jQuery, window.Adzuki || {}));
